var map = {
	"./_base-product-sidebar-wrapper.vue": "./ixcms/themes/gunoldcan/src/vue-src/base/_base-product-sidebar-wrapper.vue"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ixcms/themes/gunoldcan/src/vue-src/base _base-[\\w-]+\\.vue$";


//////////////////
// WEBPACK FOOTER
// ./ixcms/themes/gunoldcan/src/vue-src/base nonrecursive _base-[\w-]+\.vue$
// module id = ./ixcms/themes/gunoldcan/src/vue-src/base _base-[\w-]+\.vue$
// module chunks = 24